// Meta pixel helpers. The pixel itself loads in public/index.html.
// Conversion events carry an eventID that the server also sends through the
// Conversions API (server/src/services/meta.service.js), so Meta counts each once.
const PIXEL_ID = '2371937843313942';

// Advanced matching: re-init with the user so later events carry their email
// and our user id. The pixel hashes these itself before sending.
let matchedUserId = null;
export const setMetaUser = (user) => {
  if (typeof window.fbq !== 'function' || !user || !user.email || matchedUserId === user.id) return;
  matchedUserId = user.id;
  window.fbq('init', PIXEL_ID, {
    em: user.email.trim().toLowerCase(),
    fn: user.name?.split(' ')[0],
    ln: user.name?.split(' ').slice(1).join(' '),
    external_id: user.id,
  });
};

export const trackMeta = (event, params = {}, eventId) => {
  if (typeof window.fbq !== 'function') return;
  window.fbq('track', event, params, eventId ? { eventID: eventId } : undefined);
};

// Same event id as the server event sent at account creation.
export const trackMetaRegistration = (user) => {
  if (!user || !user.id) return;
  setMetaUser(user);
  trackMeta('CompleteRegistration', {}, `reg_${user.id}`);
};
